module.exports = __webpack_public_path__ + "static/img/int8.b38fa636.jpg";